import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FilterProductsComponent } from "./filter-products.component";
import { SelectModule } from "ng-select";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [FilterProductsComponent],
  imports: [CommonModule, RouterModule, SelectModule, FormsModule, TranslateModule],
  exports: [FilterProductsComponent],
})
export class FilterProductsModule { }



// WEBPACK FOOTER //
// /app/src/app/layout/filter-products/filter-products.module.ts